import Decimal from "decimal.js";
import { DateTime } from "luxon";

export type Comparator<T> = {
  [Key in keyof T as Key]: (a: T[Key], b: T[Key], rowA: T, rowB: T) => number;
};

export function stringComparator(a: string, b: string): number {
  return a.localeCompare(b);
}

export function numberComparator(a: number, b: number): number {
  return a < b ? -1 : a > b ? 1 : 0;
}

export function decimalComparator(a: Decimal, b: Decimal): number {
  return a.comparedTo(b);
}

export function datetimeComparator(a: DateTime, b: DateTime): number {
  return a < b ? -1 : a > b ? 1 : 0;
}

export function booleanComparator(a: boolean, b: boolean): number {
  return Number(a) - Number(b);
}

export function nullableComparator<T, TRow>(
  comparator: (a: T, b: T, rowA: TRow, rowB: TRow) => number,
): (a: T | null, b: T | null, rowA: TRow, rowB: TRow) => number {
  return (a: T | null, b: T | null, rowA: TRow, rowB: TRow) => {
    if (a === null && b === null) {
      return 0;
    }

    if (a === null || b === null) {
      if (a === null) {
        return -1;
      }

      return 1;
    }

    return comparator(a, b, rowA, rowB);
  };
}
